import { Grid } from '@material-ui/core';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import SchoolIcon from '@material-ui/icons/SchoolRounded';
import { getStudentOnClass, getTrainingById } from '@webapps/business';
import {
  Button,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  TableRow,
  useQuery,
  useRouter,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarStudent from 'components/Avatar/AvatarStudent';

import PropTypes from 'prop-types';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

const AbandonedStudent = () => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { params } = useRouter();
  const { id: idParam } = params;
  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState('');

  const { data: { content: infoMembers = [], totalElements } = {} } = useQuery(
    getStudentOnClass,
    {
      key: ['studentOnClassABANDONED', page, idParam + keyword],
      variables: {
        keyword,
        id: idParam,
        status: 'ABANDONED',
        page: page - 1,
        size: 10,
      },
      keepPreviousData: true,
      staleTime: 5000,
    }
  );

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  const goToPreviousPage = () => {
    window.history.back();
  };

  return (
    <div className={classes.container}>
      <Button
        className={classes.returnButton}
        onClick={goToPreviousPage}
        startIcon={<KeyboardBackspaceIcon />}
      >
        Revenir en arrière
      </Button>
      <Grid container spacing={3}>
        <Grid
          className={css({ background: 'white', margin: spacing(2) })}
          item
          xs={12}
        >
          <div
            className={cx(global.title, css({
              marginBottom: spacing(3),
              color: '#5A6DA1',
            }))}
          >
            La liste des étudiants
          </div>
          {!infoMembers?.length ? (
            <div
              className={css({
                textAlign: 'center',
                marginTop: spacing(2),
                color: '#5D75A8',
              })}
            >
              <FormattedMessage id="noElements" />
            </div>
          ) : (
            <TableContainer>
              <Table className={classes.table}>
                <TableHead
                  className={css({ background: '#4289FB', color: 'white' })}
                >
                  <TableHeadRow>
                    <TableHeadCell align="left" className={classes.tableHead}>
                      Photo, nom, prénom et ville
                    </TableHeadCell>
                    <TableHeadCell align="center" className={classes.tableHead}>
                      Formation
                    </TableHeadCell>
                    <TableHeadCell align="center" className={classes.tableHead}>
                      Type de contrat
                    </TableHeadCell>
                    <TableHeadCell align="center" className={classes.tableHead}>
                      Entreprise
                    </TableHeadCell>
                  </TableHeadRow>
                </TableHead>
                <TableBody>
                  {infoMembers?.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">
                        <div className={classes.infoCandidat}>
                          <div>
                            <AvatarStudent applicant={item?.student} />
                          </div>
                          <div
                            className={css({
                              marginLeft: spacing(1),
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                              alignItems: 'flex-start',
                            })}
                          >
                            <div
                              className={css({
                                whiteSpace: 'nowrap',
                              })}
                            >
                              {item?.student?.lastname}{' '}
                              {item?.student?.firstname}
                            </div>
                            <div
                              className={css({
                                color: '#5D75A8',
                                whiteSpace: 'nowrap',
                              })}
                            >
                              {item?.student?.address?.cityCode}{' '}
                              {item?.student?.address?.city}
                            </div>
                          </div>
                        </div>
                      </TableCell>
                      <Training id={item?.classroom?.training} />
                      <TableCell align="center">
                        {item?.student?.team
                          ? item?.student?.team?.business?.name
                          : 'Aucun'}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Grid>
      </Grid>
      <Pagination
        onChange={handlePaginationChange}
        page={page}
        pageCount={10}
        totalCount={totalElements}
      />
    </div>
  );
};

const Training = ({ id }) => {
  const { data: training = {} } = useQuery(getTrainingById, {
    key: ['training', id],
    variables: { id },
  });

  return (
    <>
      <TableCell align="center">{training?.label}</TableCell>
      <TableCell align="center">{training?.trainingType?.label}</TableCell>
    </>
  );
};

Training.propTypes = {
  id: PropTypes.string,
};

const styles = ({ spacing }) => ({
  container: {
    height: '100%',
    padding: spacing(5),
    minHeight: '100vh',
  },
  paper: {
    padding: spacing(2),
  },
  infoCandidat: { display: 'flex' },
  tableHead: {
    '&.MuiTableCell-head': {
      color: 'white',
      width: 350,
      maxWidth: '100%',
    },
  },
  containerSearch: {
    background: 'white',
    padding: spacing(3),
    paddingBottom: spacing(4),
    borderRadius: 10,

    marginTop: spacing(3),
  },
  searchContainer: {
    marginTop: spacing(2),

    display: 'flex',
    justifyContent: 'space-between',
  },
  button: {
    borderRadius: '10.0px',
  },
  returnButton: {
    color: '#5A6DA1',
    '@media only screen and (max-width:1920px)': {fontSize: '13.500px'}, '@media only screen and (max-width:1600px)': {fontSize: '13.5000px'},
    border: '1px solid #C0D9FF',
    backgroundColor: 'white',
    borderRadius: '20px',
    width: '130px',
    fontWeight: 600,
    marginTop: spacing(2),    
  },
});

export default AbandonedStudent;
